$ = require 'jquery'

module.exports =
class recruitSequence

  constructor: ->
    @$section    = $ '.section-recruit'
    @$heading    = @$section.find '.heading'
    @$subHeading = @$section.find '.sub-heading'
    @$text       = @$section.find '.text'
    @$img        = @$section.find '.img-1'
    @$buttons    = @$section.find '.buttons'
    @$icon       = @$buttons.find '.icon'
    @$arrow      = @$buttons.find '.arrow'

  getInitialVals: =>
    [
      {
        e: [ @$heading, @$icon, @$img ]
        p: { display: 'none' }
      }
      {
        e: [ @$subHeading, @$text, @$buttons ]
        p: { visibility: 'hidden' }
      }
    ]

  getSequences: =>
    {
      first: [
        {
          e: @$heading
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
        {
          e: @$subHeading.add @$text
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', 300 ]
          o: { duration: 300, visibility: 'visible' }
        }
        {
          e: @$img
          p: opacity: [ 1, 0 ]
          o: { duration: 500, display: 'block' }
        }
        {
          e: @$buttons
          p: { translateY: [ 0, -20 ] }
          o: { duration: 300, easing: 'easeOutBack', visibility: 'visible' }
        }
        {
          e: @$icon
          p: { scale: [ 1, 0 ] }
          o: { duration: 100, easing: 'easeOutQuint', display: 'block' }
        }
        {
          e: @$icon
          p: { translateY: [ -10, 0 ] }
          o: { duration: 200, easing: 'easeOutQuint' }
        }
        {
          e: @$icon
          p: { translateY: 0 }
          o: { duration: 200, easing: 'easeOutQuint' }
        }
        {
          e: @$arrow
          p: { translateX: [ 5, 0 ] }
          o: { duration: 100, easing: 'easeOutQuint' }
        }
        {
          e: @$arrow
          p: { translateX: 0 }
          o: { duration: 100, easing: 'easeOutQuint' }
        }
      ]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/recruit-sequence.coffee